<template>
    <form method="post">
        <label for="input-certificate">Certification</label>
        <input type="text" v-model="data.formation.certificate" id="input-certificate" />

        <label for="input-justification">Motivation *</label>
        <textarea
            v-model="data.formation.justification"
            :class="v && isError(v.formation.justification) ? 'error' : null"
            id="input-justification"
            cols="30"
            rows="10"
            required
        ></textarea>
        <ErrorMessage
            v-if="v && isError(v.formation.justification)"
            message="Ce champ est nécessaire"
        />
    </form>
</template>

<script>
import { state } from "../../store";
import { isError } from '../../validation';
import ErrorMessage from "../errors/ErrorMessage.vue";

export default {
    name: "SecondStep",
    components: { ErrorMessage },
    props: {
        v: {
            type: Object
        }
    },
    setup() {
        const data = state;

        return { data, isError };
    },
}
</script>

<style lang='scss' scoped>
textarea {
    resize: vertical;
    min-height: 16px;
    max-height: 350px;
}
</style>